import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { MemberGetMemberService } from 'src/app/services/member-get-member/member-get-member.service';

@Component({
  selector: 'app-mgm-modal',
  templateUrl: './mgm-modal.component.html',
  styleUrl: './mgm-modal.component.scss'
})
export class MgmModalComponent {
  @Input() openModal = false;
  @Output() closeModal = new EventEmitter<void>();

  showSuccessContent = false;
  showEmailsList = false;
  emailsControl = new FormControl('', [
    Validators.required,
    Validators.pattern(
      /^[^\s@]+@[^\s@]+\.[^\s@]+(\s*,\s*[^\s@]+@[^\s@]+\.[^\s@]+)*$/
    )
  ]);

  constructor(
    private toastService: ToastrService,
    private memberGetMemberService: MemberGetMemberService,
    private authService: AuthenticationService
  ) {}

  toggleModal() {
    this.closeModal.emit();
    // Reset do estado quando fechar o modal
    this.showSuccessContent = false;
    this.showEmailsList = false;
    this.emailsControl.reset();
  }

  sendInvites() {
    if (this.emailsControl.invalid) {
      this.toastService.error(
        'Por favor, insira e-mails válidos separados por vírgula'
      );
      return;
    }

    this.memberGetMemberService
      .sendInvites({
        vetId: this.authService.getUserId(),
        guest: this.getEmailsList()
      })
      .subscribe({
        next: () => {
          this.showSuccessContent = true;
        }
      });
  }

  copyLink() {
    const link = this.memberGetMemberService.copyLink(
      this.authService.getUserId()
    );
    navigator.clipboard.writeText(link);
    this.toastService.success('Link do Convite copiado com sucesso!');
  }

  goToSentInvites() {
    // GO TO SENT INVITES PAGE
  }

  toggleEmailsList() {
    this.showEmailsList = !this.showEmailsList;
  }

  getEmailsList(): string[] {
    const emails = this.emailsControl.value || '';
    return emails
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email);
  }

  get isFormValid(): boolean {
    return this.emailsControl.valid && !!this.emailsControl.value?.trim();
  }
}
